const getResults = communities => {
  let results = [];
  if (communities && communities.response && communities.response.data) {
    results = communities.response.data.communities
  }
  return results;
};

export { getResults };